export var ProgramStatus;
(function (ProgramStatus) {
    /** Unknown program status. */
    ProgramStatus["UNKNOWN"] = "UNKNOWN";
    /** Program is in draft mode. Customers can't earn or redeem points. */
    ProgramStatus["DRAFT"] = "DRAFT";
    /** Program is active. Customers can earn and redeem points. */
    ProgramStatus["ACTIVE"] = "ACTIVE";
    /**
     * Program is paused. Customers can't earn or redeem points while the program is paused.
     *
     * Set the program to `"ACTIVE"` to resume earning and redeeming points.
     */
    ProgramStatus["PAUSED"] = "PAUSED";
})(ProgramStatus || (ProgramStatus = {}));
export var Status;
(function (Status) {
    /** Unknown points expiration status. This value is not used. */
    Status["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** Points expiration feature is disabled. */
    Status["DISABLED"] = "DISABLED";
    /** Points expiration feature is enabled. */
    Status["ENABLED"] = "ENABLED";
})(Status || (Status = {}));
export var Type;
(function (Type) {
    /** Unknown social media channel type. */
    Type["UNKNOWN_CHANNEL"] = "UNKNOWN_CHANNEL";
    /** Facebook social media channel. */
    Type["FACEBOOK"] = "FACEBOOK";
    /** Instagram social media channel. */
    Type["INSTAGRAM"] = "INSTAGRAM";
    /** LinkedIn social media channel. */
    Type["LINKEDIN"] = "LINKEDIN";
    /** X social media channel. */
    Type["X"] = "X";
    /** TikTok social media channel. */
    Type["TIKTOK"] = "TIKTOK";
})(Type || (Type = {}));
/** Determines the reset cycle of the feature usage. */
export var FeaturePeriod;
(function (FeaturePeriod) {
    FeaturePeriod["NO_PERIOD"] = "NO_PERIOD";
    FeaturePeriod["MILLISECOND"] = "MILLISECOND";
    FeaturePeriod["SECOND"] = "SECOND";
    FeaturePeriod["MINUTE"] = "MINUTE";
    FeaturePeriod["HOUR"] = "HOUR";
    FeaturePeriod["DAY"] = "DAY";
    FeaturePeriod["WEEK"] = "WEEK";
    FeaturePeriod["MONTH"] = "MONTH";
    FeaturePeriod["YEAR"] = "YEAR";
})(FeaturePeriod || (FeaturePeriod = {}));
export var V1Type;
(function (V1Type) {
    V1Type["UNSPECIFIED"] = "UNSPECIFIED";
    V1Type["INSTALLED"] = "INSTALLED";
    V1Type["DELETED"] = "DELETED";
})(V1Type || (V1Type = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map